import { Box, Typography } from '@mui/material'
import { HlLogo } from '@ds/icons'
import { SHARE_LOGIN_HEADER_STRINGS } from './strings'

export const ShareLoginHeader = () => {
  return (
    <Box
      sx={{
        width: '100%',
        position: 'absolute',
        top: 'min(6rem, 10vh)',
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: 'text.primary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1,
          '& svg': {
            width: 32,
            height: 32,
          },
        }}
      >
        <HlLogo />
      </Box>
      <Typography variant="subtitle1" color="text.primary">
        {SHARE_LOGIN_HEADER_STRINGS.platformName}
      </Typography>
    </Box>
  )
}
